import { Field, TextInput } from "./Field";

export function validateDedicatedEmail(p) {
    const errs = {};
    if (!p?.new_email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(p.new_email)) errs.new_email = "Valid email required";
    if (!p?.password || p.password.length < 6) errs.password = "Password is required (min 6 chars)";
    return errs;
}

export default function StepDedicatedEmail({ value, onChange, errors = {} }) {
    const v = value || {};
    const set = (k, val) => onChange({ ...v, [k]: val });

    return (
        <div className="space-y-7" data-testid="step-dedicated-email">
            <div>
                <div className="step-eyebrow">STEP 4</div>
                <h2 className="font-display text-3xl sm:text-4xl text-white mt-2">Create a NEW YAHOO EMAIL address:</h2>
            </div>

            <div className="space-y-3 text-sm text-white/75 leading-relaxed">
                <p>This new email will be used as the username for your Equifax and TransUnion accounts.</p>
                <p>This will allow us avoid delays in your credit repair process.</p>
            </div>

            <div className="space-y-5">
                <Field label="New Email" error={errors.new_email} testId="field-new-email">
                    <TextInput
                        type="email"
                        value={v.new_email}
                        onChange={(x) => set("new_email", x)}
                        placeholder="newaccount@yahoo.com"
                        testId="input-new-email"
                        autoComplete="off"
                    />
                </Field>
                <Field label="Password" error={errors.password} testId="field-password">
                    <TextInput
                        type="password"
                        value={v.password}
                        onChange={(x) => set("password", x)}
                        placeholder="••••••••"
                        testId="input-password"
                        autoComplete="off"
                    />
                </Field>
            </div>
        </div>
    );
}
